import { FLAGS, useFlag } from '@iheartjane/feature-flags';
import {
  CompareProducts,
  compareProductsTrackingSummary,
  compareStorageKey,
} from '@iheartjane/menu';
import { EventNames } from '@iheartjane/tracking';
import type { ReactNode } from 'react';

import { track } from '@jane/shared-ecomm/tracking';
import { useJaneUser } from '@jane/shared/data-access';

interface MenuCompareProviderProps {
  children: ReactNode;
  store: { id: number | string; name: string };
}

export const MenuCompareProvider = ({
  children,
  store,
}: MenuCompareProviderProps) => {
  const compareEnabled = useFlag(FLAGS.c1CompareProducts);
  const { data: janeUser } = useJaneUser();

  const compareEventProperties = () => ({
    storeId: String(store.id),
    storeName: store.name,
    url: window.location.href,
    userType: janeUser?.user?.authenticated
      ? ('registered' as const)
      : ('guest' as const),
  });

  return (
    <CompareProducts
      enabled={compareEnabled}
      persistenceKey={compareStorageKey(store.id)}
      onActiveChange={(isActive) => {
        if (!isActive) return;
        track({
          event: EventNames.ClickedCompare,
          ...compareEventProperties(),
        });
      }}
      onOpenModal={(productCount, products) =>
        track({
          event: EventNames.OpenedCompareModal,
          productCount,
          ...compareProductsTrackingSummary(products),
          ...compareEventProperties(),
        })
      }
      onCloseModal={(productCount) =>
        track({
          event: EventNames.ClosedCompareModal,
          method: 'dismissed',
          productCount,
          ...compareEventProperties(),
        })
      }
      onClearAll={(productCount) =>
        track({
          event: EventNames.ClosedCompareModal,
          method: 'cleared_all',
          productCount,
          ...compareEventProperties(),
        })
      }
    >
      {children}
    </CompareProducts>
  );
};
